import React from 'react';
import Locale from 'src/i18n';
import { injectIntl } from 'react-intl';
import * as core from 'cw-ui-core';
import css from './DeleteImportedUserDialog.scss';

export const DELETE_IMPORTED_USER_DIALOG = 'DELETE_IMPORTED_USER_DIALOG';

const DeleteImportedUserDialog = props => {
    const dialogButtons = [
        <core.ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={core.formatMessage(Locale.cancel)}
            onClick={props.onCancelButtonClick}
        />,
        <core.ButtonStandard
            key="reject"
            automationName="reject"
            className={css.rejectButton}
            value={core.formatMessage(Locale.reject)}
            onClick={props.onRejectButtonClick}
        />,
    ];

    return (
        <core.Dialog
            dialogId={DELETE_IMPORTED_USER_DIALOG}
            header={core.formatMessage(Locale.deleteImportedUser)}
            buttons={dialogButtons}
            className={css.rejectImportedUsersDialog}>
            <core.ScreenMessagePanelContainer className={css.screenMessage} screenKey={DELETE_IMPORTED_USER_DIALOG} />
            <core.Label
                value={core.formatMessage(Locale.deleteImportedUserConfirmation)}
                className={css.denyMethodText}
            />
        </core.Dialog>
    );
};

export default injectIntl(DeleteImportedUserDialog);
